function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27 11.13a8.962 8.962 0 01-2.591.716 4.559 4.559 0 001.983-2.514c-.874.521-1.84.899-2.867 1.104A4.485 4.485 0 0020.23 9c-2.493 0-4.514 2.036-4.514 4.545 0 .356.04.703.117 1.035-3.75-.19-7.075-2-9.301-4.75-.39.671-.61 1.452-.61 2.286 0 1.577.797 2.968 2.007 3.783a4.489 4.489 0 01-2.045-.57v.056a4.542 4.542 0 003.62 4.457 4.54 4.54 0 01-1.19.16c-.29 0-.572-.03-.849-.085.575 1.807 2.241 3.121 4.215 3.157a9.013 9.013 0 01-5.605 1.943c-.364 0-.723-.022-1.076-.062A12.69 12.69 0 0011.918 27c8.302 0 12.84-6.926 12.84-12.933l-.015-.589A9.048 9.048 0 0027 11.13z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33
  }, props), _ref);
}

export default __webpack_public_path__ + "757581a0c899b94a3c06a28dac2e2825.svg";
export { SvgTwitter as ReactComponent };